<template>
  <div class="kvass-media-types-vimeo-preview">
    <template v-if="!isValid">
      <Icon :icon="['fab', 'vimeo']" size="2x" class="mb-1"></Icon>
      <div>
        {{ $t('videoPreviewMessage', { type: 'vimeo' }) }}
      </div>
    </template>
    <Vimeo v-else ignore-consent :value="value" class="kvass-media-types-vimeo-preview__preview" />
  </div>
</template>

<script>
import Vimeo from '@kvass/media-render/Types/Vimeo'
import Icon from '@kvass/vue2-icon'

export default {
  props: {
    value: {
      type: Object,
      default: '',
    },
    isValid: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Vimeo,
    Icon,
  },
}
</script>

<style lang="scss">
.kvass-media-types-vimeo-preview {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 0.9em;
  flex-grow: 1;
  padding: 1rem;
  background: transparent;
  height: 320px;

  &__preview {
    width: 100%;
    height: inherit;
    position: relative;
  }
  iframe {
    width: 100%;
    height: inherit;
  }

  svg {
    color: #00adef;
  }
}
.kvass-media-type-selector__modal .kvass-card {
  width: 100%;
  max-width: 700px;
}
</style>
